export const tdProduct = [1, 2, 3, 4, 5];
export const tdMatter = [1, 2, 3, 4, 5, 6];
export const tdOther = [1, 2];
export const tdGarbages = [1, 2, 3, 4];
